import { render, staticRenderFns } from "./TollAdd.vue?vue&type=template&id=43feee02&scoped=true&"
import script from "./TollAdd.vue?vue&type=script&lang=js&"
export * from "./TollAdd.vue?vue&type=script&lang=js&"
import style0 from "./TollAdd.vue?vue&type=style&index=0&id=43feee02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43feee02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VTextField})
